module.exports = __webpack_public_path__ + "d0be3b83c0aedbc52d6c998b9440d61b.pdf";